import { Tag } from 'antd';
import styled from 'styled-components';

export const StyledTag = styled(Tag)`
  padding-inline: 3px;
  font-size: 10px;
  line-height: unset;
`;

export const TagWrapper = styled.div`
  display: inline-flex;
  font-weight: 300;
  font-size: 20px;

  .ant-tag-default {
    color: rgb(109 106 106 / 88%);
  }
`;
